import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connectAsync } from 'iguazu';
import { queryModule } from 'iguazu-holocron';
import { injectIntl } from 'react-intl';
import USandCATerms from './USandCATerms';
import TNC from './TNC';

export const TnC = ({ locale, TermsAndConditions }) => {
  switch (locale) {
    case 'en-ca':
    case 'fr-ca':
    case 'en-us':
      return <USandCATerms locale={locale} />;
    case 'es-mx':
    case 'it-it':
    case 'de-de':
    case 'en-hk':
    case 'en-sg':
    case 'fr-fr':
    case 'es-es':
    case 'nl-nl':
    case 'sv-se':
      return <TNC locale={locale} />;
    default:
      return TermsAndConditions && <TermsAndConditions directory="hub" />;
  }
};

TnC.propTypes = {
  locale: PropTypes.string.isRequired,
  TermsAndConditions: PropTypes.func.isRequired,
};

export const loadDataAsProps = ({ store: { dispatch }, ownProps }) => (
  ownProps && ownProps.langPack && ownProps.langPack.showTC
    ? { TermsAndConditions: () => dispatch(queryModule('axp-travel-terms-and-conditions')) } : ''
);

const hocChain = compose(
  connectAsync({ loadDataAsProps }),
  injectIntl
);

export default hocChain(TnC);
